<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('Agregar nuevas etapas')"
          :directory="$t('de evaluación/testificación')"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
<!--          <button-->
<!--            type="button"-->
<!--            class="btn btn-success btn-with-shadow ml-3"-->
<!--            @click="openDeleteModal"-->
<!--          >-->
<!--            Procesar-->
<!--          </button>-->
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-sm-6" :class="{ 'loading-opacity': preloader }">
        <div class="mt-2">
          <strong>
            Registro de Ingreso de solicitud de acreditación y Acuse Recibo
          </strong>
          <br />
          <button
            type="submit"
            class="btn btn-success"
            @click.prevent="
              openTab(receipt_return_report, 'receipt_return_report')
            "
          >
            <app-icon name="file" />
            {{ $t("view") }}
          </button>
        </div>
      </div>

      <div
        class="col-sm-6"
        :class="{ 'loading-opacity': preloader }"
        style="text-align: right"
      >
        <div class="mt-2" style="text-align: center">
          <strong>Solicitud de acreditación firmada</strong>
          <br />
          <a
            class="btn btn-success"
            :href="`${request_signed}`"
            target="_blank"
          >
            <app-icon name="file" /> Ver</a
          >
        </div>
      </div>
    </div>
    <hr />
    <div class="row" :class="{ 'loading-opacity': preloader }">
      <div class="col-sm-6">
        <strong> AREA </strong>
        <p>{{ application_name }}</p>
      </div>
      <div class="col-sm-6">
        <strong>Norma a evaluar</strong>
        <p>{{ rule_name }}</p>
      </div>
    </div>
    <hr />
    <div class="row" :class="{ 'loading-opacity': preloader }">
      <div class="col-sm-6">
        <strong> Expediente </strong>
        <br />
        <a
          :href="`/accreditations/applications/${accreditationApplicationId}`"
          target="_blank"
          >{{ record }}</a
        >
      </div>
      <div class="col-sm-6">
        <!-- <strong> Evaluación In Situ </strong> -->
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-sm-12" style="text-align: center">
        <button
          type="button"
          class="btn btn-primary mr-2"
          @click="addInputTestistifications"
          :class="{ 'loading-opacity': preloader }"
          :disabled="registers.length > 0"
        >
          Registrar etapa
        </button>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-sm-12">
        <h5 class="text-primary">Etapas Registradas</h5>
      </div>
    </div>
    <hr />
    <div
      class="row"
      v-for="(item, key) in registers"
      :key="key"
      :class="{ 'loading-opacity': preloader }"
    >
      <div class="col-sm-8">
        <p>
          <strong>Evaluación In situ {{ item.code }}</strong>
        </p>
      </div>
      <div class="col-sm-4">
        <div class="row">
          <div class="col-sm-3">
            <button
              v-if="item.state == 1"
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="addCriticalLocation(item.id, item.code)"
            >
              <app-icon name="plus" />
              LC
            </button>
          </div>
          <div class="col-sm-3">
            <button
              v-if="item.state == 1"
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="addTestification(item.id, item.code)"
            >
              <app-icon name="plus" />
              T
            </button>
          </div>

          <div class="col-sm-2" v-if="item.state_planification == 0">
            <button
              v-if="item.state == 0"
              type="submit"
              class="btn btn-danger btn-sm mr-2"
              @click="updateEvaluationState(item.id)"
            >
              <app-icon name="power" />
            </button>
            <button
              v-if="item.state == 1"
              type="submit"
              class="btn btn-success btn-sm mr-2"
              @click="updateEvaluationState(item.id)"
            >

              <app-icon name="power" />
            </button>
          </div>
          <div class="col-sm-2" v-if="item.state_planification == 1">
            <!-- <button
              type="submit"
              class="btn btn-success btn-sm mr-2"
              @click="updateEvaluationState(item.id)"
              disabled
            > -->
            <button
              type="submit"
              class="btn btn-success btn-sm mr-2"
              @click="updateEvaluationState(item.id)"
            >

              <app-icon name="power" />
            </button>
          </div>
        </div>
      </div>
      <br />
      <br />
      <hr />

      <div class="col-sm-10 mx-auto" :class="{ 'loading-opacity': preloader }">
        <div class="row d-flex" v-for="(items, key) in item.testifications" :key="key">
          <div class="col-sm-6 my-2" v-if="items.state == 1">
            <p class="text-center d-flex align-items-center justify-content-end mx-5 mt-2">
              <strong> {{ items.code }}</strong>
            </p>
          </div>
          <div class="col-sm-6 my-2" v-if="items.state == 0">
            <p class="text-center d-flex align-items-center justify-content-end mx-5 mt-2">
              <strong class="text-danger">Estado inactivo</strong>
            </p>
          </div>
          <div class="col-sm-6 my-2" v-if="items.state_planification == 0">
            <div class="row" v-if="item.state == 1">
              <div class="col-sm-2" v-if="items.state == 1">
                <button
                  type="button"
                  class="btn btn-success btn-sm mr-2"
                  @click="stateTestification(items.id)"
                >
                  <app-icon name="power" />
                </button>
              </div>
              <div class="col" v-if="items.state == 1 && accType == 'INSPECCION'">
                <div class="input-group input-group-sm">
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Código"
                      aria-label="Código"
                      aria-describedby="button-addon2"
                      v-model="items.codeRef"
                  >
                  <div class="input-group-append">
                    <button
                        class="btn btn-primary btn-sm"
                        type="button"
                        id="button-addon2"
                        @click="updateCode(items, item.code)"
                    >Guardar</button>
                  </div>
                </div>
              </div>


              <div class="col-sm-2" v-if="items.state == 0">
                <button
                  type="button"
                  class="btn btn-danger btn-sm mr-2"
                  @click="stateTestification(items.id)"
                >
                  <app-icon name="power" />
                </button>
              </div>
            </div>
            <div class="row" v-if="item.state == 0">
              <div class="col-sm-2" v-if="items.state == 1">
                <!-- <button
                  type="button"
                  class="btn btn-success btn-sm mr-2"
                  :disabled="true"
                >
                  <app-icon name="power" />
                </button> -->
                <button
                  type="button"
                  class="btn btn-success btn-sm mr-2"
                >
                  <app-icon name="power" />
                </button>
              </div>
              <div class="col-sm-2" v-if="items.state == 0" :disabled="true">
                <button type="button" class="btn btn-danger btn-sm mr-2">
                  <app-icon name="power" />
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-6 my-2" v-if="items.state_planification == 1">
            <div class="row" v-if="item.state == 1">
              <div class="col-sm-2" v-if="items.state == 1">
                <button
                    type="button"
                    class="btn btn-success btn-sm mr-2"
                    @click="stateTestification(items.id)"
                >
                  <app-icon name="power" />
                </button>
              </div>

              <div class="col" v-if="items.state == 1 && accType == 'INSPECCION'">
                <div class="input-group input-group-sm">
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Código"
                      aria-label="Código"
                      aria-describedby="button-addon2"
                      v-model="items.codeRef"
                  >
                  <div class="input-group-append">
                    <button
                        class="btn btn-primary btn-sm"
                        type="button"
                        id="button-addon2"
                        @click="updateCode(items, item.code)"
                    >Guardar</button>
                  </div>
                </div>
              </div>

              <div class="col-sm-2" v-if="items.state == 0">
                <button
                    type="button"
                    class="btn btn-danger btn-sm mr-2"
                    @click="stateTestification(items.id)"
                >
                  <app-icon name="power" />
                </button>
              </div>
            </div>
            <div class="row" v-if="item.state == 0">
              <div class="col-sm-2" v-if="items.state == 1">
                <!-- <button
                  type="button"
                  class="btn btn-success btn-sm mr-2"
                  :disabled="true"
                >
                  <app-icon name="power" />
                </button> -->
                <button
                    type="button"
                    class="btn btn-success btn-sm mr-2"
                >
                  <app-icon name="power" />
                </button>
              </div>
              <div class="col-sm-2" v-if="items.state == 0" :disabled="true">
                <button type="button" class="btn btn-danger btn-sm mr-2">
                  <app-icon name="power" />
                </button>
              </div>
            </div>
          </div>
          <br /><br />
        </div>
        <br />
      </div>
      <br />
    </div>
    <hr />
    <!-- <form ref="form" :class="{ 'loading-opacity': preloader }" data-url="/accreditationtechnical/quotations/update">
      <div class="row" style="width: 100%">
        <div class="col-sm-12" style="text-align: center">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            Procesar
          </button>
        </div>
      </div>
    </form> -->
    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";
export default {
  name: "RegisterStages",
  mixins: [FormMixin],
  components: {},

  props: {
    accreditationApplicationId: String,
  },
  data() {
    return {
      record: "",
      preloader: false,
      TestificationList: [],
      evaluations: [],
      inputs: [],
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      number_testifications: 1,
      deleteConfirmationModalActive: false,
      deleteConfirmationModalActive: false,
      number_concat: 0,
      accreditation: [],
      rule_name: "",
      application_name: "",
      registers: [],
      dataEvaluation: [],
      attached_file: {},
      receipt_return_report: "",
      request_signed: "",
      accType: null
    };
  },
  created() {
    this.TestificationList = this.$store.state.accreditation.testification;
    this.accreditationData();
    this.evaluationTestification();
  },
  watch: {
    "$store.state.accreditation.testification": function () {
      this.TestificationList = this.$store.state.accreditation.testification;
    },
  },
  methods: {
    returnPage() {
      window.location.href =
        "/accreditationtechnical/addEvaluationTestification";
    },
    openTab(obj) {
      const w = window.open(obj.full_url, "_blank");
      w.focus();
    },
    updateCode(value, original){
      this.preloader = true;
      const code = `${original}-${value.codeRef}`;
      const url = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/updateCodeEval/${value.id}`;
      axios.patch(url, {code}).then(()=>{
        this.preloader = false;
        this.$toastr.s(this.$t("Código actualizado"));
        value.code = code;
      }).catch(()=>{
        this.preloader = false;
        this.$toastr.e(this.$t("No se pudo actualizar el código"));
      })
    },
    confirmed() {
      this.deleteLoader = true;
      const url = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/update`;
      const request = {};
      request["accreditation_application_id"] = this.accreditationApplicationId;

      axios
        .post(url, request)
        .then(({ data: res }) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelled();
          if (res.status === true) {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    addInputTestistifications() {
      var accreditationData = {};
      accreditationData["accreditationApplicationId"] =
        this.accreditationApplicationId;
      accreditationData["accreditation_area_id"] =
        this.accreditation.accreditation_area_id;
      var selectedUrl = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/storeEvaluation`;
      axios.post(selectedUrl, accreditationData).then((response) => {
        this.$toastr.s(this.$t("updated_success"));
        this.evaluationTestification();
      });
    },

    stateTestification(id) {
      this.preloader = true;
      var selectedUrl = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/updateTestificationState/${id}`;
      axios.get(selectedUrl).then((response) => {
        this.evaluationTestification();
        this.preloader = false;
        this.$toastr.s(this.$t("updated_success"));
      });
    },
    evaluationTestificationCharge() {
      var selectedUrl = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/evaluationTestification/${this.accreditationApplicationId}`;
      axios.get(selectedUrl).then((response) => {
        this.registers = response.data;
      });
    },

    evaluationTestification() {
      var selectedUrl = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/evaluationTestification/${this.accreditationApplicationId}`;
      axios.get(selectedUrl).then((response) => {
        this.registers = response.data;
        if (this.registers.length > 0){
            this.accType = this.registers[0].activity.name;
            if (this.accType == 'INSPECCION'){
              this.registers[0].testifications = this.registers[0].testifications.map(item=>{
                const [code] = item.code.split('-').reverse();
                return {...item, codeRef: code}
              });
            }
        }
      });
    },
    addTestification(id, code) {
      this.preloader = true;
      var selectedUrl = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/verifyTestification/${id}`;
      axios.get(selectedUrl).then((response) => {
        var testificationNumber = response.data.length;
        var column = {};
        column["cod_testification_in_situ"] =
          code + "-T".concat(testificationNumber + 1);
        column["id_pcr_evaluation_in_situ"] = id;
        column["accreditation_id"] = this.accreditationApplicationId;
        this.preloader = false;
        var selectedUrl = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/storeTestification`;
        axios.post(selectedUrl, column).then((response) => {
          this.evaluationTestificationCharge();
          this.preloader = false;
          this.$toastr.s(this.$t("created_success"));
        });
      });
    },

    addCriticalLocation(id, code) {
      this.preloader = true;
      var selectedUrl = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/verifyCriticalLocation/${id}`;
      axios.get(selectedUrl).then((response) => {
        var criticalNumber = response.data.length;
        var column = {};
        column["cod_critical_location"] =
          code + "-LC".concat(criticalNumber + 1);
        column["id_pcr_evaluation_in_situ"] = id;
        column["accreditation_id"] = this.accreditationApplicationId;
        this.preloader = false;
        var selectedUrl = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/storeCriticalLocation`;
        axios.post(selectedUrl, column).then((response) => {
          this.evaluationTestificationCharge();
          this.preloader = false;
          this.$toastr.s(this.$t("created_success"));
        });
      });
    },
    accreditationData() {
      this.preloader = true;
      var selectedUrl = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/form/${this.accreditationApplicationId}`;
      axios.get(selectedUrl).then((response) => {
        this.rule_name = response.data.accreditation_area.name;
        this.application_name =
          response.data.accreditation_activity.application_name;
        this.accreditation = response.data;
        this.record = response.data.record;
        this.receipt_return_report = response.data.receipt_return_report;
        this.preloader = false;
        if (response.data.request_signed) {
          this.request_signed = response.data.request_signed.full_url;
        }
      });
    },

    updateEvaluationState(id) {
      this.preloader = true;
      var selectedUrl = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification/updateEvaluationState/${id}`;
      axios.get(selectedUrl).then((response) => {
        this.evaluationTestificationCharge();
        this.preloader = false;
        this.$toastr.s(this.$t("updated_success"));
      });
    },

    submit() {
      if (!this.inputs.file) {
        this.$toastr.e(this.$t("Es necesario subir un archivo"));
      } else {
        let formData = new FormData();

        formData.append("file", this.inputs.file);
        formData.append(
          "accreditation_application_id",
          this.accreditationApplicationId
        );
        formData.append(
          "accreditation_application_id",
          this.accreditationApplicationId
        );
        if (this.delete_file) {
          formData.append("delete_file", true);
        }
        this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("created_success"));
      window.location = `${actions.TECHNICAL_ANALYSIS_REPORT}/addEvaluationTestification/generateEvaluationTestification`;
    },
  },
};
</script>